module.exports = __webpack_public_path__ + "img/solution2.313de05f.png";